import styles from "./AppLoader.module.css";

const AppLoader = () => {
  return (
    <span className={`${styles.loader} loader text-5xl font-bold`}>
      CHARGEMENT...
    </span>
  );
};

export default AppLoader;
